export default __webpack_public_path__ + "static/media/KOD0005-min.eeea9a09.webp";